import axiosInstance from "../../axios/axiosInstance";
import { CREATE_FOOTER_TEMPLATE, DELETE_FOOTER_TEMPLATE, EDIT_FOOTER_TEMPLATE, FOOTER_LISTING, FOOTER_TEMPLATE_SINGLE_LISTING, STATUS_UPDATE_FOOTER } from "../../constants";



export const createFooterTemplate = (props) => onResponse => {

    try {
        axiosInstance.post(CREATE_FOOTER_TEMPLATE, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const editFooterTemplate = (id, values) => onResponse => {
    try {
        axiosInstance.put(`${EDIT_FOOTER_TEMPLATE}/${id}`, values)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) {
        console.error('Error in editTemplate:', error);
    }
};

export const getFooterListing = ({ skip, limit, search }) => onResponse => {
    const BASE_URL = `${FOOTER_LISTING}?skip=${skip}&limit=${limit}&search=${search}`;
    try {
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const getFooterTemplateDetails = (id) => (onResponse) => {
    try {
        axiosInstance
            .get(FOOTER_TEMPLATE_SINGLE_LISTING + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) { }
};

export const statusUpdateFooter = (id) => onResponse => {

    try {
        axiosInstance.put(STATUS_UPDATE_FOOTER + '/' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};


export const deleteFooterTemplate = (id) => onResponse => {

    try {
        axiosInstance.delete(DELETE_FOOTER_TEMPLATE + '/' + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};
